const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export function isNonEmptyBillResourceId(v) {
  return v != null && v !== "" && v !== EMPTY_GUID;
}

function pickBillRequestTemplateResourceId(payload) {
  if (!payload || typeof payload !== "object") return undefined;
  const id = payload.billTemplateResourceId;
  return isNonEmptyBillResourceId(id) ? id : undefined;
}

export function resolveBillReportResourceIdFallback(
  billSettings,
  billingRequestPayload,
  isBillRequestPost,
) {
  const fromRequest =
    isBillRequestPost && billingRequestPayload
      ? pickBillRequestTemplateResourceId(billingRequestPayload)
      : undefined;

  const fromDefault = isNonEmptyBillResourceId(billSettings?.defaultBillResourceId)
    ? billSettings.defaultBillResourceId
    : undefined;

  return isNonEmptyBillResourceId(fromRequest) ? fromRequest : fromDefault;
}

export function resolveEffectiveBillReportResourceId(
  selectedBillReportResourceId,
  billSettings,
  billingRequestPayload,
  isBillRequestPost,
) {
  if (isNonEmptyBillResourceId(selectedBillReportResourceId)) {
    return selectedBillReportResourceId;
  }
  return resolveBillReportResourceIdFallback(
    billSettings,
    billingRequestPayload,
    isBillRequestPost,
  );
}
